import { BaseApi } from '.';


export const AppCodeApi = {
  getAllCategoryCodes,
  getCategoryParentCodes,
  getChildrenDefectCodes
};

function getAllCategoryCodes(category){
  return BaseApi.get(`/appCodes/search/findByCategoryOrderByName?category=${category}`);
}

function getCategoryParentCodes(category){
  return BaseApi.get(`/appCodes/search/findByCategoryAndParentIsNullOrderByName?category=${category}`);
}

function getChildrenDefectCodes(parentId){
  return BaseApi.get(`/appCodes/search/findByParent_Seq?parent=${parentId}`);
}
